import React from "react";
import { useLocalization } from "../../../context/LocalizationContext";
import Modal from "../Modal";
import Button from "../Button";
import warnIcon from "../../../assets/icons/newDesign/warn.svg";
import "./EndSessionConfirmModal.css";

interface EndSessionConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isEnding?: boolean;
}

const EndSessionConfirmModal: React.FC<EndSessionConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isEnding = false,
}) => {
  const { t } = useLocalization();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="" message="" customLayout noScroll>
      <div className="end-session-modal-body">
        <img
          src={warnIcon}
          alt=""
          aria-hidden="true"
        />
        <h2 className="end-session-modal-title">
          {t("endSession.confirmTitle")}
        </h2>
        <p className="end-session-modal-description">
          {t("endSession.confirmDescription")}
        </p>
        <div className="end-session-modal-actions">
          <Button
            variant="secondary"
            onClick={onConfirm}
            disabled={isEnding}
          >
            {isEnding ? t("endSession.ending") : t("endSession.confirmButton")}
          </Button>
          <button
            className="end-session-modal-cancel-btn"
            onClick={onClose}
            disabled={isEnding}
          >
            {t("cancel")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default EndSessionConfirmModal;
